// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { PersonRef } from './personRef.zod.ts';

export const FeedbackRowOut = zod.object({
  "author": PersonRef,
  "category": zod.enum(['bug', 'enhancement', 'suggestion', 'question']),
  "closed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "comment_count": zod.int(),
  "created_at": zod.iso.datetime({"offset":true}),
  "id": zod.uuid(),
  "last_activity_at": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['new', 'in_review', 'planned', 'in_progress', 'resolved', 'declined', 'cancelled']),
  "title": zod.string()
});

export type FeedbackRowOut = zod.input<typeof FeedbackRowOut>;
export type FeedbackRowOutOutput = zod.output<typeof FeedbackRowOut>;
